import styled from '@emotion/styled';
import { theme } from '../../theme';
const SMALL = '24px';
const REGULAR = '36px';
const LARGE = '48px';
const getAvatarStyling = (size) => {
    switch (size) {
        case 'small':
            return Object.assign({ height: SMALL, width: SMALL, minHeight: SMALL, minWidth: SMALL }, theme.typography.IB70);
        case 'regular':
            return Object.assign({ height: REGULAR, width: REGULAR, minHeight: REGULAR, minWidth: REGULAR }, theme.typography.IB90);
        case 'large':
            return Object.assign({ height: LARGE, width: LARGE, minHeight: LARGE, minWidth: LARGE }, theme.typography.IB100);
        default:
            return Object.assign({ height: REGULAR, width: REGULAR, minHeight: REGULAR, minWidth: REGULAR }, theme.typography.IB70);
    }
};
export const StyledAvatar = styled.div `
	background-color: ${theme.colors.LM_NU20T};
	border-radius: 50%;
	color: ${theme.colors.LM_NU100};
	display: flex;
	align-items: center;
	justify-content: center;

	${({ size }) => getAvatarStyling(size)};
`;
//# sourceMappingURL=Avatar.styled.js.map